import { SKELETON_STYLES, createSkeletonHTML } from './skeletonComponents.js';

function injectStyles() {
  const styleId = 'ein-skeleton-loader-styles';
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = SKELETON_STYLES;
    document.head.appendChild(style);
  }
}

function showSkeleton(container) {
  if (!container) {
    console.warn('EIN Chart: No container provided for skeleton loader');
    return;
  }

  injectStyles();

  container.innerHTML = createSkeletonHTML();
}

function removeSkeleton(container) {
  return new Promise((resolve) => {
    if (!container) {
      console.warn(
        'EIN Chart: No container provided to remove skeleton loader',
      );
      resolve();
      return;
    }

    const skeletonElement = container.querySelector('#ein-skeleton-loader');
    if (skeletonElement) {
      // Add fade-out class to trigger transition
      skeletonElement.classList.add('fade-out');

      // Remove element after transition completes (200ms)
      setTimeout(() => {
        if (skeletonElement.parentNode) {
          skeletonElement.remove();
        }
        resolve();
      }, 200);
    } else {
      resolve();
    }
  });
}

export { showSkeleton, removeSkeleton };
